import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '@/components/Reveal';
import { useServices } from '@/data/useServices';

export default function ServiciosProyectos() {
  const { services: SERVICES, loading, error } = useServices();
  const [hoveredSlug, setHoveredSlug] = useState(null);

  return (
    <div
      className="text-[#58677A]"
      data-testid="servicios-proyectos-page"
      style={{
        backgroundColor: '#EFECE7',
        backgroundImage: "url('/assets/backgrounds/nosotros-bg.jpg')",
        backgroundRepeat: 'repeat-y',
        backgroundSize: '100% auto',
        backgroundPosition: 'top center',
      }}
    >
      <section className="py-14 sm:py-16 lg:py-20">
        <div className="container-link">
          <Reveal>
            <h1
              className="text-center uppercase mb-12 lg:mb-14"
              style={{
                color: '#ED6B24',
                fontSize: 'clamp(22pt, 5.5vw, 30pt)',
                fontFamily: 'Gotham, sans-serif',
                fontWeight: 900,
                letterSpacing: '0.02em',
              }}
              data-testid="services-hub-title"
            >
              ¿QUÉ NECESITAS?
            </h1>
          </Reveal>

          <Reveal>
            {loading && SERVICES.length === 0 && (
              <div className="flex flex-col gap-5 lg:gap-6" aria-label="Cargando servicios">
                {[0, 1, 2].map((item) => (
                  <div
                    key={item}
                    className="rounded-[28px] bg-white/45 animate-pulse"
                    style={{ minHeight: 'clamp(100px, 16vw, 195px)' }}
                  />
                ))}
              </div>
            )}
            {!loading && error && SERVICES.length === 0 && (
              <p className="rounded-2xl border border-[#58677A]/15 bg-white/50 px-5 py-4 text-center text-sm text-[#58677A]/75">
                Los servicios no están disponibles temporalmente.
              </p>
            )}
            <div
              className="flex flex-col gap-5 lg:gap-6"
              data-testid="services-hub-section"
            >
              {SERVICES.map((s) => {
                const sizes = s.hubBannerSizes || {
                  smallPct: 100,
                  mainPct: 100,
                };

                const smallScale = (sizes.smallPct || 100) / 100;
                const mainScale = (sizes.mainPct || 100) / 100;
                const isHovered = hoveredSlug === s.slug;

                // Todos los banners empiezan ampliados y hacen zoom out al hover.
                const imageScale = isHovered ? 1 : 1.08;

                return (
                  <Link
                    key={s.slug}
                    to={`/servicios/${s.slug}`}
                    className="relative block rounded-[28px] overflow-hidden border border-black/10 hover:border-black/30 transition-colors duration-300"
                    data-testid={`service-hub-banner-${s.slug}`}
                    onMouseEnter={() => setHoveredSlug(s.slug)}
                    onMouseLeave={() => setHoveredSlug(null)}
                    onFocus={() => setHoveredSlug(s.slug)}
                    onBlur={() => setHoveredSlug(null)}
                    style={{
                      '--small-scale': smallScale,
                      '--main-scale': mainScale,
                    }}
                  >
                    {/* Imagen del banner */}
                    <div
                      className="absolute inset-0 bg-cover bg-right sm:bg-center origin-right sm:origin-center"
                      style={{
                        backgroundImage: `url(${s.hubBanner || s.bgImage})`,
                        transform: `scale(${imageScale})`,
                        transition:
                          'transform 700ms cubic-bezier(0.22, 1, 0.36, 1)',
                        willChange: 'transform',
                      }}
                    />

                    {/* Capa oscura */}
                    <div
                      className="absolute inset-0"
                      style={{
                        background:
                          'linear-gradient(110deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.20) 60%, rgba(0,0,0,0.10) 100%)',
                      }}
                    />

                    <div
                      className="relative px-6 sm:px-10 lg:px-14 py-5 sm:py-7 lg:py-8 flex items-center"
                      style={{
                        minHeight: 'clamp(100px, 16vw, 195px)',
                      }}
                    >
                      <div className="max-w-[70%] sm:max-w-[65%] lg:max-w-[60%] text-white">
                        {s.hubBannerText?.top && (
                          <p
                            className="uppercase font-semibold tracking-[0.04em] text-white/95 mb-1 sm:mb-2 leading-tight"
                            style={{
                              fontSize:
                                'calc(clamp(11px, calc(11px + 5 * ((100vw - 640px) / 640)), 16px) * var(--small-scale, 1))',
                            }}
                            data-testid={`service-hub-banner-top-${s.slug}`}
                          >
                            {s.hubBannerText.top}
                          </p>
                        )}

                        <h2
                          className="uppercase font-black leading-[0.95] text-white tracking-tight"
                          style={{
                            fontSize:
                              'calc(clamp(30px, calc(30px + 42 * ((100vw - 640px) / 640)), 72px) * var(--main-scale, 1))',
                          }}
                          data-testid={`service-hub-banner-main-${s.slug}`}
                        >
                          {s.hubBannerText?.main || s.hubName || s.name}
                        </h2>

                        {s.hubBannerText?.bottom && (
                          <p
                            className="uppercase font-semibold tracking-[0.04em] text-white/95 mt-1 sm:mt-2 leading-tight"
                            style={{
                              fontSize:
                                'calc(clamp(11px, calc(11px + 5 * ((100vw - 640px) / 640)), 16px) * var(--small-scale, 1))',
                            }}
                            data-testid={`service-hub-banner-bottom-${s.slug}`}
                          >
                            {s.hubBannerText.bottom}
                          </p>
                        )}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}